import React from 'react';

import { IConversation } from '../../../api/types';
import { useConversationSendMessage } from '../../../redux/hooks/answer/conversation-hooks';
import { useAppSelector } from '../../../redux/hooks/app-hooks';

import { ChatInputView } from './ChatInputView';

interface ChatInputComponentProps {
    conversation?: IConversation;
}

const ChatInputComponent: React.FC<ChatInputComponentProps> = ({ conversation }) => {
    const activeConversationId = useAppSelector((state) => state.chatTab.activeConversationId) ?? '';
    const { sendMessage, abortMessage, isLoading, isGenerating } = useConversationSendMessage(activeConversationId);

    if (!activeConversationId) {
        return null;
    }

    return (
        <ChatInputView
            conversation={conversation}
            onSubmit={sendMessage}
            onAbort={abortMessage}
            isLoading={isGenerating}
            disabled={isLoading}
        />
    );
};

export const ChatInput = React.memo(ChatInputComponent);
